export const FLOAT_NOTIF_CONSTANT = {
  PUSH_NOTIF: "PUSH_NOTIF",
  POP_NOTIF: "POP_NOTIF",
  REMOVE_NOTIF: "REMOVE_NOTIF",
  CLEAR_NOTIF: "CLEAR_NOTIF",
};
